<template>
    <div>
        <PageHeader :page="page" :template="'2'" @action="createNew" v-if="!state.loading"/>
        <div class="" v-if="!state.loading">
            <DataTable :tableData="tableData" @view="viewVendor" @edit="edit"
            />
        </div>
        <div class="temp-row" v-if="state.loading" style="text-align: center;">
            <img src="@/assets/img/ajldr.gif" style="width:100px"/>
        </div>
    </div>
    <ModalView
        :isVisible="state.CreateModal"
        :fixclose="true"
        @close="state.CreateModal = false">
        
        <DynamicForm :columns="2"
            :fields="newFields" @submit="addVendor"
            :submitting="state.submitting" :errors="state.errors"
            :success="state.success" />
    </ModalView> 

    
    <ModalView
        :isVisible="state.ViewModal"
        :fixclose="true"
        @close="state.ViewModal = false">
        
        <FormView :columns="2"
            :fields="viewFields" 
            :loading="state.modalLoading" />
    </ModalView> 

    
    <ModalView
        :isVisible="state.editModal"
        :fixclose="true"
        @close="state.editModal = false">
        
        <div v-if="!state.modalLoading">
            <DynamicForm :columns="2"
                :fields="editFields" @submit="editVendor"
                :submitting="state.submitting" :errors="state.errors"
                :success="state.success" />
        </div>
        <div v-else style="text-align: center;">
            <img src="@/assets/img/ajldr.gif" style="width:100px"/>
          </div>
    </ModalView> 

    <ModalView
        :isVisible="state.notesModal"
        :fixclose="true"
        @close="state.notesModal = false">
        <div v-if="!state.modalLoading">
            <div v-if="state.notesview">
                <div class="v-flex align-items-center justify-content-between">
                    <h2>Customer Notes</h2>
                    <span class="btn-primary" @click="addNote">Add Note</span>
                </div>
                <HistoryItem v-for="(item, i) in notes" :key="i" :hitem="item" :action="historyAction" 
                    :class="{inactive: !item.isAuth}" @edit="editNote" @delete="deleteNote"/>
            </div>
            <div v-if="state.createnote">
                <DynamicForm :columns="2"
                    :fields="cnFields" @submit="sendNote"
                    :submitting="state.submitting" :errors="state.errors"
                    :success="state.success" />
            </div>
        </div>
        <div v-else style="text-align: center;">
            <img src="@/assets/img/ajldr.gif" style="width:100px"/>
        </div>
        
    </ModalView>

</template>

<script>
import icons from '@/assets/js/icons.js';
import { defineComponent, reactive, ref, onMounted} from 'vue';
import PageHeader from '@/components/PageHeader.vue';
import DataTable from '@/components/DataTable.vue';
import DynamicForm from '@/components/DynamicForm.vue';
import FormView from '@/components/FormView.vue';
import ModalView from '@/components/ModalView.vue';
import call from "../composables/call.js";
import { urls } from "../assets/js/urls.js";
import { useRouter } from 'vue-router';
import { usePermissions } from '@/composables/usePermissions';
import HistoryItem from '@/components/HistoryItem.vue';

export default defineComponent({
    components:{PageHeader, DataTable,DynamicForm,ModalView,FormView,HistoryItem},
    setup(){
        const router = useRouter();
        const { hasPermission } = usePermissions();
        const createForm=ref(null);
        const state=reactive({CreateModal:false, submitting:false,error:[],success:false,
        loading:true, ViewModal:false,modalLoading:true,editModal:false,
        });
        const notes=ref([])
        const svgIcons = ref(icons);
        const page=ref({title:"Vendors List", btn:"Add new",
        desc:"Manage your vendors database with ease. View vendors details"})
        
        var action_label=[icons.view],
        action=["view"]
        if(!hasPermission('Customers List', 'create')){
            page.value.btn="";
        }

        if(hasPermission('Customers List', 'edit')){
            action.push("edit");
            action_label.push(icons.edit)
        }
        const newFields=ref([])
        newFields.value.push(
            { name: "Add Vendor", number: "1",data: 
                [
                    { type: 'text', name: 'name', label: 'Name',
                        value: ""  },
                    {type: 'text', name: 'phone', label: 'Phone No.',
                        value: ""},
                    {type: 'text', name: 'email', label: 'Email Address',
                        value: ""},
                    {type: 'text', name: 'address', label: 'Address',
                        value: ""},
                    {type: 'text', name: 'purpose', label: 'Purpose',
                        value: ""}
                ]
            }
        )
        

        const tableData = ref({
            rows: [],
            loading: true,
            columns: [
                { label: "Name" },
                { label: "Email" },
                { label: "Phone" },
                { label: "Purpose" }
            ],
            options:{
                label:"Action",
                action_label:action_label,
                action:action
            },
            total:0
        });

        const viewFields=ref([])
        const editFields=ref([])

        
            
        
        function createNew(){
            state.success=false;
            state.error=[]
            state.CreateModal=true;
        }

        function setTable(msg){
            var data={}
            tableData.value.loading = false;
            tableData.value.rows.length=0
            Object.keys(msg).forEach(set => {
                data={id:msg[set].id,status:msg[set].status};
                var v=[];
                Object.keys(msg[set].val).forEach(row => {
                v.push(msg[set].val[row])
                });
                data.val=v;
                tableData.value.rows.push(data)
            });
            tableData.value.total=tableData.value.rows.length
        }

        onMounted(() => {
            call({
                url:urls.vendor,
                data:{startVendor:""},
                success:(res)=>{
                state.loading=false
                if(res.status){
                    var d=res.msg;
                    setTable(d.vendors);
                }else{
                    alert(res.msg);
                }
                }
            })
        });

        function setErrors(res){
            var errors=[];
            Object.keys(res.msg).forEach(key => {
            var e=res.msg[key],er="";
            Object.keys(e).forEach(k => {
                er+=er=="" ? e[k] : ", "+e[k]
            })
            errors.push(er);
            });
            state.errors=errors;
        }

        function addVendor(data){
            state.submitting=true;
            state.errors=[];
            data.addVendor="";
            call({
                url:urls.vendor,
                data:data,
                success:(res)=>{
                state.submitting=false;
                if(res.status){
                    state.success=true;
                    setTable(res.msg);
                }else{
                    setErrors(res)
                }
                }
            })
        }

        function viewVendor(i){
            state.modalLoading=true
            state.ViewModal=true;
            state.success=false;
            state.submitting=false;
            state.errors=[];
            var id=tableData.value.rows[i].id
            call({
                url:urls.vendor,
                data:{getVendor:id},
                success:(res)=>{
                state.modalLoading=false;
                if(res.status){
                    viewFields.value.length=0;
                    var c=res.msg.vendor;
                    viewFields.value.push(
                        { name: "Vendor Info", number: "1",data: 
                            [{ label: 'Name',name: 'name',
                            value: c.name  },
                            {label: 'Phone No.',name: 'phone',
                            value: c.phone},
                            {label: 'Email Address',name: 'email',
                            value: c.email},
                            {label: 'Purpose',name: 'purpose',
                            value: c.purpose},
                            {label: 'Added By',name: 'added_by',
                            value: c.added_by},
                            {label: 'Date',name: 'date',
                            value: c.date},
                            {label: 'Address',name: 'address',
                            value: c.address},
                            ]
                        }
                    );
                }else{
                    setErrors(res)
                }
                }
            })
        }

        function edit(i){
            state.modalLoading=true
            state.editModal=true;
            state.success=false;
            state.submitting=false;
            state.errors=[];
            var id=tableData.value.rows[i].id
            call({
                url:urls.vendor,
                data:{getVendor:id},
                success:(res)=>{
                    state.modalLoading=false;
                    if(res.status){
                        editFields.value.length=0;
                        var c=res.msg.vendor;
                        editFields.value.push(
                            { name: "Edit Vendor", number: "1",data: 
                                [{ label: 'Name',name: 'name',type: 'text',
                                value: c.name  },
                                {label: 'Phone No.',name: 'phone',type: 'text',
                                value: c.phone},
                                {label: 'Email Address',name: 'email',type: 'text',
                                value: c.email},
                                {label: 'Purpose',name: 'purpose',type: 'text',
                                value: c.purpose},
                                {label: 'Address',name: 'address',type: 'text',
                                value: c.address},
                                {label: '',name: 'id',type: 'hidden',
                                value: c.id},
                                ]
                            }
                        );
                    }else{
                        setErrors(res)
                    }
                }
            })
        }

        function editVendor(data){
            state.submitting=true;
            state.errors=[];
            data.addVendor="";
            call({
                url:urls.vendor,
                data:data,
                success:(res)=>{
                state.submitting=false;
                if(res.status){
                    state.success=true;
                    setTable(res.msg);
                }else{
                    setErrors(res)
                }
                }
            })
        }

        function showComplaints(i){
            if(hasPermission('CRM', 'view')){
                var id=tableData.value.rows[i].id
                router.push({ name: 'ccomplaints', params: { customerId: id } });
            }
            
        }

        function subscription(i){
            var id=tableData.value.rows[i].id
            router.push({ name: 'subhistory', params: { customerId: id } });
        }


        return{page,icons: svgIcons.value,tableData,state,createForm,viewVendor,notes,
            newFields,createNew,addVendor,viewFields,edit,editFields,editVendor,
            showComplaints,subscription,
        }
    }
});
</script>
<style scoped>
h2, .h2 {
    font-size: 20px; margin: 0;
}
:deep(.inactive .icwrap){display:none}
:deep(.icwrap .trash_ic){stroke:var(--red)}
</style>